/* unplugin-vue-components disabled */import { render } from "./ImgRotate.vue?vue&type=template&id=1cd08af8&scoped=true"
import script from "./ImgRotate.vue?vue&type=script&lang=js"
export * from "./ImgRotate.vue?vue&type=script&lang=js"

import "./ImgRotate.vue?vue&type=style&index=0&id=1cd08af8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd08af8"]])

export default __exports__